<template>
	<div class="my-invoice" v-loading="loading">
        <div class="title">
            <span>我的发票</span>
            <span>(tips：下载时如果遇到浏览器阻止，请点击允许)</span>
        </div>
        <div class="detail">
            <el-table :data="invoiceList" border>
                <el-table-column prop="order_no" label="订单编号" width="180"></el-table-column>
                <el-table-column prop="create_time" label="订单时间" width="180"></el-table-column>
                <el-table-column prop="pay_money" label="发票金额" width="90"></el-table-column>
                <el-table-column prop="invoice_id" label="发票号码" width="200"></el-table-column>
                <el-table-column prop="invoice_code" label="发票代码" width="200"></el-table-column>
                <!-- 操作 -->
                 <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleDownload(scope.row)">下载发票</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pager">
            <el-pagination  background  :pager-count="5"  :total="total"  prev-text="上一页"  next-text="下一页" 
            :current-page.sync="invoiceInfo.page" :page-size.sync="invoiceInfo.page_size" @size-change="handlePageSizeChange" @current-change="handleCurrentPageChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import { apiInvoiceInfo } from "@/api/member/invoice";
    export default {
        name: "my_invoice",
        components: {},
        data: () => {
            return {
                invoiceInfo: {
                    page: 1,
                    page_size: 10,
                },
                invoiceList: [],
                total: 0,
                loading: true,
                yes: true,
            }
        },
        computed: {

        },
        created() {
            this.getInvoiceList()
        },
		mounted() {},
        methods: {
            getInvoiceList() {
                this.loading = true
                apiInvoiceInfo(this.invoiceInfo)
                    .then(res => {
                        if (res.code == 0 && res.data) {
                            this.invoiceList = res.data.data || [];
                            this.total = res.data.total || 0;
                        }
                        this.loading = false
                    })
                    .catch(err => {
                        this.$message.error(err.message)
                    })
            },
            handlePageSizeChange(num) {
                this.invoiceInfo.page_size = num
                this.getInvoiceList()
            },
            handleCurrentPageChange(page) {
                this.invoiceInfo.page = page
                this.getInvoiceList()
            },
            handleDownload(row) {
                window.open(row.invoice_pdf_url);
                this.$message.success("下载成功")
            }
        }
    }
</script>
<style lang="scss" scoped>
	.my-invoice{
        display: flex;
        flex-direction: column;
        gap: 12px;
        background-color: #fff;
        padding: 12px;
        box-sizing: border-box;
        .title{
            display: flex;
            align-items: baseline;
            gap: 12px;
            >span:nth-child(1){
                font-size: 24px;
                font-weight: bold;
                color: #333333;
            }
            >span:nth-child(2){
                font-size: 16px;
                color: #ff547b;
            }
        }
    }
    .pager{
        padding: 0 !important;
        margin: 0 !important;
    }
</style>
